import { render, staticRenderFns } from "./AutoCheckGlass.vue?vue&type=template&id=5c06515c&"
import script from "./AutoCheckGlass.vue?vue&type=script&lang=js&"
export * from "./AutoCheckGlass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports